<script>
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      topics: [],
      listener: null
    }
  },

  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices'
    })
  },

  created () {
    this.createTopics()
      .then(() => this.createSourceEvent())
      .catch(err => console.log('err \n', err))
  },

  methods: {
    async createTopics () {
      const topics = []
      const ids = await this.getOfficesIds()

      ids.forEach(id => topics.push({
        topic: `app-drconecta/doctorOffice/${id}/agenda`,
        event: 'agenda-reload'
      }))

      if (this.fn_IS_DOCTOR()) {
        topics.push({
          topic: `app-drconecta/doctor/${this.$store.getters.getProfile.id}`,
          event: 'new-notification'
        })
        topics.push({
          topic: `secretary/doctor/${this.$store.getters.getProfile.id}`,
          event: 'new-notification'
        })
      }
      // Sem rota de notificação pra secretária ainda
      // } else {
      //   topics.push({
      //     topic: `app-drconecta/secretary/${this.$store.getters.getProfile.id}`,
      //     event: 'new-notification'
      //   })
      // }

      this.topics = topics

      return true
    },

    getOfficesIds () {
      return this.doctorOffices.map(office => office.id)
    },

    createSourceEvent () {
      const url = new URL(process.env.MERCURE_API)
      this.topics.forEach(topic => url.searchParams.append('topic', topic.topic))
      this.listener = new EventSource(url)
      this.listener.onmessage = response => this.handleResponse(JSON.parse(response.data))
    },

    handleResponse (data) {
      const { event } = data
      const { payload } = data

      EventBus.$emit(event, payload)
    }
  },

  render: () => null
}
</script>
